import { GetterTree } from "vuex";
import { EventSearchState } from "./types";
import { RootState } from "../types";
import { state } from "../event-category-setup";

export const getters: GetterTree<EventSearchState, RootState> = {
	events: state => state.Events,
	eventAlarmTypes: state => state.AlarmTypes,
	eventCategories: state => state.Categories,
	eventDeviceTypes: state => state.DeviceTypes,
	eventOperators: state => state.Operators,
	searchableEventTypes: state => state.SearchableEventTypes,
	searching: state => state.searching,
};
